import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Router, RouterModule } from '@angular/router';
import { defer, finalize, map, takeWhile, timer } from 'rxjs';
import { EventTrackerNavigationReasons } from 'src/app/shared/constants';

const REDIRECT_TIME_MS = 5_000;
const STEP_MS = 100;

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    imports: [
        // Angular
        CommonModule,
        RouterModule,
        // Angular Material
        MatCardModule,
        MatProgressBarModule,
        // Own
    ]
})
export class NotFoundComponent {
    protected readonly EventTrackerNavigationReasons = EventTrackerNavigationReasons;

    protected readonly redirectUrl = '/';

    protected readonly progressBarValueObs = defer(() => {
        const start = Date.now();

        return timer(0, STEP_MS).pipe(
            map(() => Date.now() - start),
            map((elapsedMs) => Math.max(0, Math.min(100, 100 * (elapsedMs / REDIRECT_TIME_MS)))),
            takeWhile((progressBarValue) => progressBarValue < 100, true),
            finalize(() =>
                this._router.navigateByUrl(this.redirectUrl, { state: { navigatedBy: EventTrackerNavigationReasons.NotFoundPageTimer } }),
            ),
        );
    });

    constructor(private readonly _router: Router) {}
}
